import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('team', {
  account_name: '',
  account_status: '',
  settings: {},
  loan_auto_import: '',
  active_los_connected_app_name: '',
})
